import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssetDisposalReducer } from '../reducers';

export const selectAssetDisposalFeature = createFeatureSelector<AssetDisposalReducer.AssetDisposalState>(AssetDisposalReducer.featureName);

export const selectAssetDisposal = createSelector(selectAssetDisposalFeature, (state: AssetDisposalReducer.AssetDisposalState) => state.item);
